import 'extensions/checkout/checkout.scss';
import './OCST.scss';
import {PageManager} from 'genesis-packages/core';
import ExitTrigger from '@mvps-genesis/exit-trigger';
import AddressFields from 'extensions/checkout/AddressFields';
import Checkout from 'extensions/checkout/Checkout.js';
import HTMLFormValidatorScrollTop from 'extensions/form-validation/HTMLFormValidatorScrollTop';

export default class OCST extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	// eslint-disable-next-line max-lines-per-function
	onReady () {

		new ExitTrigger('.js-exit-trigger', {
			message: 'Are you sure you want to exit checkout?',
			redirectUrl: this.pageContext.Basket_Url
		});

		new Checkout();

		if (this.pageContext.Customer_Login !== '') {
			new AddressFields();
		}

		const ocstForm = document.getElementById('ocst-form');
		if (ocstForm) {
			this.resetButtons(ocstForm);
			ocstForm.addEventListener('submit', () => this.handleSubmit(ocstForm));

			ocstForm.HTMLFormValidator = new HTMLFormValidatorScrollTop({
				formElement: ocstForm,
				wrapperSelector: '.c-form-list__item'
			});
		}
	}

	handleSubmit (form) {
		const buttons = form.querySelectorAll('[type="submit"]');
		const loadingText = 'Loading...';

		if (buttons) {
			for (const button of buttons) {
				button.disabled = true;

				if (button.nodeName === 'INPUT') {
					button.setAttribute('data-original-text', button.value);
					button.value = loadingText;
				} else {
					button.setAttribute('data-original-text', button.innerText);
					button.innerText = loadingText;
				}
			}
		}
	}

	resetButtons (form) {
		const buttons = form.querySelectorAll('[type="submit"]');
		if (buttons) {
			for (const button of buttons) {
				const originalText = button.getAttribute('data-original-text');
				button.disabled = false;

				if (!originalText) {
					continue;
				}

				if (button.nodeName === 'INPUT') {
					button.value = originalText;
				} else {
					button.innerText = originalText;
				}
			}
		}
	}

};
